import { render } from "./Theme.vue?vue&type=template&id=28d3cfab"
import script from "./Theme.vue?vue&type=script&lang=js"
export * from "./Theme.vue?vue&type=script&lang=js"
script.render = render

export default script